import React from 'react';

import { Tr, Td } from 'xpi-black-ui/Common/Table';

function Leg({ leg }) {
  return (
    <Tr>
      <Td>{leg.asset}</Td>
      <Td>{leg.spotFormatted}</Td>
      <Td>{leg.operationFormatted}</Td>
      <Td>{leg.quantity.value}</Td>
      <Td>{leg?.opcao?.label}</Td>
      <Td>{leg.maturityDateFormatted}</Td>
      <Td>{leg.strike.view}</Td>
      <Td>{leg?.strike.converted}</Td>
    </Tr>
  );
}

export default Leg;
